var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',{style:({ maxWidth: '700px', margin: 'auto' })},[_vm._v(_vm._s(_vm.$t('strings.toolkitContents')))]),_c('div',{staticClass:"toolkits"},[_c('ToolkitTiles',{attrs:{"workshops":Object.values(_vm.$t('toolkits'))}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }